var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Plotly',{attrs:{"data":_vm.data,"layout":_vm.layout,"scrollZoom":true,"displaylogo":false,"id":"plotly2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }